import React from 'react';
import AppRoutes from './routes';
import MsalAuthProvider from './lib/msal/MsalAuthProvider';
import { AuthProvider } from './loginpage/AuthContext';
import { InstanceProvider } from './context/InstanceContext';
import { SelectedFileProvider } from './context/SelectedFileContext';
import { FileProvider } from './context/FileContext'; // 

function App() {
  return (
    <MsalAuthProvider>
      <AuthProvider>
        <InstanceProvider>
          <SelectedFileProvider>
            <FileProvider> 
              <AppRoutes />
            </FileProvider>
          </SelectedFileProvider>
        </InstanceProvider>
      </AuthProvider>
    </MsalAuthProvider>
  );
}

export default App;
